module.exports = __webpack_public_path__ + "static/img/huodongshuoming-bg.8e5bc11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/app/huodongshuoming-bg.png
// module id = Ay9z
// module chunks = 69